import { React, useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import lodash from 'lodash';
import moment from 'moment';

import { useLanguage } from '../../../Context/LanguageContext';
import FetchModule from '../../Share/Network/FetchModule';

import RegistrationLoading from './RegistrationLoading.js';
import WaitingPagePaymentModal from './WaitingPagePaymentModal.js';
import OptionSelectBox from '../../../MemberRegistration/Model/OptionSelectBox.js';
import CustomInput from '../../../MemberRegistration/Component/CustomInput.js';
import PaymentOptionSettingSelectBox from '../../../MemberRegistration/Model/PaymentOptionSettingSelectBox.js';
import CalenderInput from '../../../MemberRegistration/Component/CalendarInput.js';
import PaymentOptionCustomInput from '../../../MemberRegistration/Component/PaymentOptionCustomInput.js';
import TotalModalWrapper from '../../Share/Normal/TotalModalWrapper';
import AddPaymentOptionModal from '../../../MemberRegistration/Model/AddPaymentOptionModal.js';
import DiscountAmountInput from '../../../Component/MemberComponent/DiscountAmountInput.js';

import WhiteTrashIcon from '../../../image/WhiteTrashIcon.png';
import { ReactComponent as PlusSvg } from '../../../image/Plus.svg';

// 현장 결제 모달 컴포넌트 //
const OnSitePaymentModal = (props) => {
  const {
    isUsePaymentSystem,
    userData,
    merchantUid,
    rerendering,
    setRerendering,
    cancel,
    closeFn
  } = props;

  const history = useHistory();
  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [data, setData] = useState(undefined);
  const [isClicked, setIsClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [productName, setProductName] = useState('');
  const [productCoach, setProductCoach] = useState('');
  const [productValidity, setProductValidity] = useState(0);
  const [card, setCard] = useState(0);
  const [cash, setCash] = useState(0);
  const [point, setPoint] = useState(0);
  const [totalPoint, setTotalPoint] = useState(0);

  const [totalRegistData, setTotalRegistData] = useState(undefined);

  const DefaultPaymentOption = [{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }];

  const [isEdit, setIsEdit] = useState(false);
  const [isClickedAddPaymentOption, setIsClickedAddPaymentOption] = useState(false);

  const [isInProgress, setIsInProgress] = useState(false);

  const [prevSalesColor, setPrevSalesColor] = useState(theme.text);
  const [prevSalesDDayColor, setPrevSalesDDayColor] = useState(theme.white);

  const [memberships, setMemberships] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categorizedMemberships, setCategorizedMemberships] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({ id: 0, name: '선택' });
  const [selectedMembership, setSelectedMembership] = useState({ id: 0, name: '선택' });
  const [paymentOptions, setPaymentOptions] = useState([{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }]);
  const [selectedPaymentOptions, setSelectedPaymentOptions] = useState([{ id: 0, name: '현금', price: 0 }]);

  const [startDate, setStartDate] = useState(moment().format('YYYY.MM.DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY.MM.DD'));
  const [approvalDate, setApprovalDate] = useState(moment().format('YYYY.MM.DD'));
  const [totalMax, setTotalMax] = useState(-1);
  const [discount, setDiscount] = useState('0');
  const [notReceived, setNotReceived] = useState('0');

  const InfoViewRef = useRef();

  // 결제 정보 불러오기 //
  useEffect(() => {
    if (merchantUid === undefined) return;

    let requestData = { merchantUid: merchantUid };

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('sales/merchant_auto_data/', 'POST', requestData);

        if (responseData.status === 200) {
          setData(responseData.data[0]);
        }
        else if (responseData.status === 401) {
          alert(t('waiting.onSitePaymentModal.alertLoginRequired'));
          history.push('/login');
        }
      }
    )();
  }, [merchantUid])

  // Point 현황 불러오기 //
  useEffect(() => {
    let requestData = {
      storeId: userData.storeId,
      userId: userData.userId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('point/available/find_member', 'POST', requestData);

        if (responseData.status === 200) {
          setTotalPoint(responseData.data.totalPoint);
        }
      }
    )();
  }, [userData])

  // 카테고리 및 회원권 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('membership/', 'GET');

        if (responseData.status === 200) {
          setMemberships(responseData.data.memberShips);
          setCategories(responseData.data.categories);
        }
        else if (responseData.status === 401) history.push('/login');
      }
    )();
  }, [history])

  // 결제수단 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('payment_option/', 'GET');

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
        }
        else if (responseData.status === 401) history.push('/login');
      }
    )();
  }, [])

  // 회원권 생성 또는 수정여부 결정 //
  useEffect(() => {
    if (data === undefined) return;

    const willSelectMembership = memberships.find(m => m.name === userData.itemName) || { id: 0, name: '선택' };
    const willSelectCategory = willSelectMembership.id !== 0
      ? (categories.find(c => c.id === willSelectMembership.categoryId) || { id: 0, name: '선택' })
      : { id: 0, name: '선택' };

    setSelectedCategory(willSelectCategory);

    setTimeout(() => {
      setSelectedMembership(willSelectMembership)
      setStartDate(moment().format('YYYY.MM.DD'));

      let division = 'days';

      if (data.validityUnit === 'year') division = 'year';
      else if (data.validityUnit === 'month') division = 'month';

      setEndDate(moment().add(data.validity, division).subtract(1, 'days').format('YYYY.MM.DD'));
      setApprovalDate(moment().format('YYYY.MM.DD'));

      // 고객 요청 금액으로 결제수단 세팅 //
      let newPaymentOptions = [];

      if (data.cashPrice > 0) newPaymentOptions.push({ id: 0, name: '현금', price: data.cashPrice });
      if (data.cardPrice > 0) newPaymentOptions.push({ id: 0, name: '카드', price: data.cardPrice });
      if (data.point > 0) newPaymentOptions.push({ id: 0, name: '포인트', price: data.point });
      if (newPaymentOptions.length === 0) newPaymentOptions.push({ id: 0, name: '현금', price: 0 });

      setSelectedPaymentOptions(newPaymentOptions);
    }, 150);

    setTotalMax(data.totalMax);
  }, [categories, memberships, data])

  // 카테고리에 따라 회원권 정렬하기 //
  useEffect(() => {
    if (selectedCategory === undefined || selectedCategory.id === 0) {
      setCategorizedMemberships([]);
      setSelectedMembership({ id: 0, name: '선택' });
      return;
    }

    let newCategorizedMemberships = [];

    for (let i = 0; i < memberships.length; i++) {
      if (selectedCategory.id === memberships[i].categoryId) {
        newCategorizedMemberships.push(memberships[i]);
      }
    }

    setSelectedMembership({ id: 0, name: '선택' });
    setCategorizedMemberships(newCategorizedMemberships);
  }, [selectedCategory, memberships])

  // 회원권 종료일 자동 세팅 //
  useEffect(() => {
    if (startDate === '' || selectedMembership.id === 0) return;

    let validity = selectedMembership.validity;
    let division = selectedMembership.validityUnit;

    setEndDate(moment(startDate, 'YYYY.MM.DD').add(validity, division).subtract(1, 'days').format('YYYY.MM.DD'));
  }, [startDate, selectedMembership]);

  // 포인트 결제 자동 세팅 //
  useEffect(() => {
    if (userData === undefined || userData.point === null || userData.point === undefined) return;

    setSelectedPaymentOptions([{ id: 0, name: '포인트', price: userData.point }]);
  }, [userData])

  // 미수금 산정하기 //
  useEffect(() => {
    if (selectedMembership.id === 0) {
      setNotReceived(0);
      return;
    }

    let totalPrice = 0;

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== '') totalPrice += parseInt(selectedPaymentOptions[i].price.toString().replaceAll(',', '') ?? 0);
    }

    if (discount !== '') totalPrice += parseInt(discount.toString().replaceAll(',', ''));

    setNotReceived(Math.max(selectedMembership.price - totalPrice, 0));
  }, [selectedMembership, selectedPaymentOptions, discount]);

  // 회원권 총 횟수 세팅 //
  useEffect(() => {
    if (selectedMembership.id === 0) setTotalMax(-1);
    else setTotalMax(selectedMembership.totalMax);
  }, [selectedMembership])

  // 포인트 결제 자동 세팅 //
  useEffect(() => {
    if (userData === undefined || userData.point === null || userData.point === undefined) return;

    setSelectedPaymentOptions([{ id: 0, name: '포인트', price: userData.point }]);
  }, [userData])

  // 최대 수강 횟수 변경시 //
  function onChangeTotalMax(value) {
    const onlyNumber = value.replace(/[^0-9]/g, '');
    setTotalMax(Number(onlyNumber));
  }

  // 결제 옵션 추가 버튼 클릭시 //
  function onClickAdditionOption() {
    setIsClickedAddPaymentOption(true);
  }

  // 이전 등록 회원권 정보 뷰 정리 //
  function onCalcPrevSalesInfo(className) {
    if (userData === undefined || userData.prevSales === undefined || userData.prevMemberShip === undefined) return '';

    if (className === 'MemberShipName') return userData.prevSales.itemName;
    else if (className === 'Date') {
      const fmt = t('calendarInput.rangeDateFormat');
      return moment(userData.prevUsage.startDate).format(fmt) + ' - ' + moment(userData.prevUsage.endDate).format(fmt);
    }
    else if (className === 'TotalPrice') {
      if (userData.prevUsage.selectedPaymentOptions === undefined || userData.prevUsage.selectedPaymentOptions.length === 0) {
        if (userData.prevUsage.cardPrice === 0 && userData.prevUsage.cashPrice === 0) return t('waiting.onSitePaymentModal.free');
        else if (userData.prevUsage.cardPrice === 0) return userData.prevUsage.cashPrice.toLocaleString('ko-KR') + ' - ' + t('waiting.onSitePaymentModal.cashDisplay');
        else if (userData.prevUsage.cashPrice === 0) return userData.prevUsage.cardPrice.toLocaleString('ko-KR') + ' - ' + t('waiting.onSitePaymentModal.cardDisplay');
        else return (parseInt(userData.prevUsage.cashPrice) + parseInt(userData.prevUsage.cardPrice)).toLocaleString('ko-KR') + ' - ' + t('waiting.onSitePaymentModal.mixedPayment');
      }
      else {
        const allSame = userData.prevUsage.selectedPaymentOptions.every(item => item.paymentOptionName === userData.prevUsage.selectedPaymentOptions[0].name);
        const totalPrice = userData.prevUsage.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0);

        if (allSame) return totalPrice.toLocaleString('ko-KR') + ' - ' + userData.prevUsage.selectedPaymentOptions[0].paymentOptionName;
        else return totalPrice.toLocaleString('ko-KR') + ' - ' + t('waiting.onSitePaymentModal.mixedPayment');
      }
    }
    else if (className === 'NotReceivedPrice') return userData.prevUsage.notReceivedPrice.toLocaleString('ko-KR');
    else if (className === 'Validity') {
      const diffDay = moment(userData.prevUsage.endDate).diff(moment(), 'day');
      if (diffDay > 0) return 'D - ' + diffDay;
      else if (diffDay === 0) return 'D - day';
      else return 'D + ' + Math.abs(diffDay);
    }
    else if (className === 'TotalMax') {
      if (userData.prevUsage.totalMax === -1) return userData.prevUsage.courseTakeCount + '/∞';
      else return userData.prevUsage.courseTakeCount + '/' + userData.prevUsage.totalMax;
    }
  }

  // 이전 등록 회원권 정보 호버링 //
  function onMouseOverPrevSales() {
    setPrevSalesColor(theme.primary);
    setPrevSalesDDayColor(theme.primary);
  }

  // 이전 등록 회원권 정보 호버링 //
  function onMouseLeavePrevSales() {
    setPrevSalesColor(theme.text);
    setPrevSalesDDayColor(theme.white);
  }

  // 이전 기록 클릭시 회원권 세팅 //
  function onClickPrevSales() {
    if (userData === undefined) return;

    const willSelectCategory = categories.find(c => c.id === userData.prevMemberShip.categoryId) || { id: 0, name: '선택' };
    const willSelectMembership = memberships.find(m => m.id === userData.prevMemberShip.id) || { id: 0, name: '선택' };

    setSelectedCategory(willSelectCategory);

    setTimeout(() => (
      setSelectedMembership(willSelectMembership)
    ), 150);

    if (userData.prevUsage.selectedPaymentOptions !== undefined
      && userData.prevUsage.selectedPaymentOptions.length > 0) {
      let newSelectedPaymentOptions = lodash.cloneDeep(userData.prevUsage.selectedPaymentOptions);

      for (let i = 0; i < newSelectedPaymentOptions.length; i++) {
        newSelectedPaymentOptions[i].id = newSelectedPaymentOptions[i].paymentOptionId;
      }

      setSelectedPaymentOptions(newSelectedPaymentOptions);
    }
    else {
      let newSelectedPaymentOptions = [];

      if (userData.prevUsage.cashPrice !== 0) newSelectedPaymentOptions.push({ id: 0, name: '현금', price: userData.prevUsage.cashPrice });
      if (userData.prevUsage.cardPrice !== 0) newSelectedPaymentOptions.push({ id: 0, name: '카드', price: userData.prevUsage.cardPrice });
      if (userData.prevUsage.point !== 0) newSelectedPaymentOptions.push({ id: 0, name: '포인트', price: userData.prevUsage.point });

      setSelectedPaymentOptions(newSelectedPaymentOptions);
    }

    setTotalMax(userData.prevUsage.totalMax);
    setDiscount(userData.prevUsage.discountPrice.toString());
    setNotReceived(userData.prevUsage.notReceivedPrice.toString());
  }

  // 결제수단 모달 내에서 결제수단 저장하기 클릭시 //
  function onClickSavePaymentOption(optionName) {
    if (optionName === '') {
      alert(t('waiting.onSitePaymentModal.alertPaymentOptionNameRequired'));
      return;
    }

    if (isLoading) {
      alert(t('waiting.onSitePaymentModal.alertSaveInProgress'));
      return;
    }

    setIsLoading(true);

    let requestData = {
      optionName: optionName
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/save', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/login');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 결제 수단 삭제버튼 클릭시 //
  function onClickDeleteOption(paymentOptionId) {
    if (isLoading) {
      alert(t('waiting.onSitePaymentModal.alertDeleteInProgress'));
      return;
    }

    setIsLoading(true);

    let requestData = {
      paymentOptionId: paymentOptionId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/delete', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/login');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 회원권 결제 수단 변경시 //
  function onChangeSelectedPaymentOptions(data, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions[index].id = data.id;
    newSelectedPaymentOptions[index].name = data.name;

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 금액 변경시 //
  function onChangePaymentOptionPrice(value, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();
    let finalValue = value.replaceAll(',', '');

    if (finalValue !== '') newSelectedPaymentOptions[index].price = parseInt(finalValue).toLocaleString('ko-KR');
    else newSelectedPaymentOptions[index].price = finalValue;

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 할인 금액 변경시 //
  function onChangeDiscount(value) {
    let finalValue = value.replaceAll(',', '');

    if (finalValue !== '') setDiscount(parseInt(finalValue).toLocaleString('ko-KR'));
    else setDiscount(finalValue);
  }

  // 회원권 결제 수단 추가 버튼 클릭시 //
  function onClickAddPaymentOptions() {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    const remaining = parseInt(notReceived.toString().replaceAll(',', '')) || 0;

    newSelectedPaymentOptions.push({ id: 0, name: '현금', price: remaining });

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 수단 제거 버튼 클릭시 //
  function onClickDeletePaymentOptions(index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.splice(index, 1);

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 등록을 위해 모든 데이터가 채워졌는지 여부 확인 //
  function checkAvailableRegistration() {
    if (startDate === '') {
      alert(t('waiting.onSitePaymentModal.alertStartDateRequired'));
      return false;
    }

    if (endDate === '') {
      alert(t('waiting.onSitePaymentModal.alertEndDateRequired'));
      return false;
    }

    if (approvalDate === '') {
      alert(t('waiting.onSitePaymentModal.alertPaymentDateRequired'));
      return false;
    }

    if (selectedMembership.id === 0) {
      alert(t('waiting.onSitePaymentModal.alertSelectMembership'));
      return false;
    }

    let checkStartDate = moment(startDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'));
    let checkEndDate = moment(endDate.replaceAll('.', '-') + 'T23:59:59');

    if (checkEndDate.isBefore(checkStartDate)) {
      alert(t('waiting.onSitePaymentModal.alertEndDateInvalidShort'));
      return false;
    }

    return true;
  }

  // 등록하기 버튼 클릭시 //
  function onClickRegistrationButton() {
    if (selectedMembership.id === 0) {
      alert(t('waiting.onSitePaymentModal.alertSelectMembership'));
      return;
    }

    let checkStartDate = moment(startDate.replaceAll('.', '-') + 'T00:00:00');
    let checkEndDate = moment(endDate.replaceAll('.', '-') + 'T23:59:59');

    if (checkEndDate.isBefore(checkStartDate)) {
      alert(t('waiting.onSitePaymentModal.alertEndDateInvalidShort'));
      return;
    }

    let finalCashPrice = 0;
    let finalCardPrice = 0;
    let finalPoint = 0;

    let finalSelectedPaymentOptions = [];

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== ''
        && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
    }

    for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
      if (finalSelectedPaymentOptions[i].id === 0) {
        if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '카드') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '포인트') finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
      }

      finalSelectedPaymentOptions[i].price = parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
    }

    if (parseInt(finalPoint) > 0 && parseInt((finalPoint).toString().replaceAll(',', '')) > parseInt(totalPoint.toString().replaceAll(',', ''))) {
      alert(t('waiting.onSitePaymentModal.alertPointExceeded'));
      return;
    }

    setProductName(selectedMembership.name);
    setProductCoach('');
    setProductValidity(selectedMembership.validity);
    setCard(finalCardPrice);
    setCash(finalCashPrice);
    setPoint(finalPoint);

    let name = userData.userName;
    let birthDay = (userData.birthDay.slice(7, 8) === '1' || userData.birthDay.slice(7, 8) === '2') ? '19' + userData.birthDay.slice(0, 6) : '20' + userData.birthDay.slice(0, 6);
    let gender = (userData.birthDay.slice(7, 8) === '1' || userData.birthDay.slice(7, 8) === '3') ? 'male' : 'female';
    let phone = userData.phone;
    let id = userData.userId;
    let profile = userData.profile;

    let registData = {
      name: name,
      birthDay: birthDay,
      gender: gender,
      phone: phone,
      linkCoachId: id,
      storeId: parseInt(window.sessionStorage.getItem('StoreId')),
      memberShipName: selectedMembership.name,
      profile: profile,
      memberDetail: '',
      approval: moment().format('YYYY-MM-DDTHH:mm:ss'),
      totalMax: totalMax,
      startDate: moment(startDate).format('YYYY-MM-DDTHH:mm:ss'),
      endDate: moment(endDate).format('YYYY-MM-DDTHH:mm:ss'),
      memberShipId: selectedMembership.id,
      cardPrice: finalCardPrice,
      cashPrice: finalCashPrice,
      discount: parseInt(discount.toString().replaceAll(',', '')),
      notReceived: parseInt(notReceived.toString().replaceAll(',', '')),
      point: finalPoint,
      membershipPaymentOptions: finalSelectedPaymentOptions
    }

    onClickOnSitePayment(registData);
  }

  // 현장 결제 버튼 클릭시 //
  function onClickOnSitePayment(registData) {
    if (isLoading) {
      alert(t('waiting.onSitePaymentModal.alertPaymentInProgress'));
      return;
    }

    setIsLoading(true);

    let requestData = {
      merchantUid: merchantUid,
      cardPrice: registData.cardPrice,
      cashPrice: registData.cashPrice,
      discount: registData.discount,
      notReceived: registData.notReceived,
      point: registData.point,
      approvalDate: moment(approvalDate).format('YYYY-MM-DDTHH:mm:ss'),
      membershipPaymentOptions: registData.membershipPaymentOptions
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('sales/onSite/effectiveness', 'POST', requestData);

        if (responseData.status === 200) {
          cancelFunction(responseData.data);
          setIsLoading(false);
        }
        else if (responseData.status === 201) {
          alert(t('waiting.onSitePaymentModal.alertInvalidRequest'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 202) {
          alert(t('waiting.onSitePaymentModal.alertPaymentAlreadyProcessed'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 204) {
          alert(t('waiting.onSitePaymentModal.alertPaymentNotFound'));
          setIsLoading(false);
          return;
        }
      }
    )();
  }

  // 링코페이 결제자의 신청을 승인시 //
  function onClickPaymentOnPayple(totalRegistData) {
    if (isLoading) {
      alert(t('waiting.onSitePaymentModal.alertPaymentInProgress'));
      return;
    }

    setIsLoading(true);

    totalRegistData.merchantUid = merchantUid;

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('member/registration/waiting/linkpay', 'POST', totalRegistData);

        if (responseData.status === 200) {
          cancel(responseData.data);
          setIsLoading(false);
        }
        else if (responseData.status === 201) {
          alert(t('waiting.onSitePaymentModal.alertNotLinkCoachMember'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 202) {
          alert(t('waiting.onSitePaymentModal.alertDataNotFound'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 203) {
          alert(t('waiting.onSitePaymentModal.alertDataNotFound'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 204) {
          alert(t('waiting.onSitePaymentModal.alertCardNotRegistered'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 205) {
          alert(t('waiting.onSitePaymentModal.alertPaymentError'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 206) {
          alert(t('waiting.onSitePaymentModal.alertSubscriptionNoChange'));
          setIsLoading(false);
          return;
        }
        else {
          alert(responseData.error);
          setIsLoading(false);
          return;
        }
      }
    )();
  }

  // 현장결제 승인 후 회원 등록 요청 //
  function cancelFunction(merchant_uid) {
    let name = userData.userName;
    let birthDay = (userData.birthDay.slice(7, 8) === '1' || userData.birthDay.slice(7, 8) === '2') ? '19' + userData.birthDay.slice(0, 6) : '20' + userData.birthDay.slice(0, 6);
    let gender = (userData.birthDay.slice(7, 8) === '1' || userData.birthDay.slice(7, 8) === '3') ? 'male' : 'female';
    let phone = userData.phone;
    let id = userData.userId;
    let memberShipName = productName;
    let profile = userData.profile;
    let memberShipId = selectedMembership.id;

    let requestData = {
      name: name,
      birthDay: birthDay,
      gender: gender,
      phone: phone,
      linkCoachId: id,
      storeId: window.sessionStorage.getItem('StoreId'),
      memberShipName: memberShipName,
      profile: profile,
      memberDetail: '',
      approval: moment().format('YYYY-MM-DDTHH:mm:ss'),
      totalMax: totalMax,
      startDate: moment(startDate).format('YYYY-MM-DDTHH:mm:ss'),
      endDate: moment(endDate).format('YYYY-MM-DDTHH:mm:ss'),
      memberShipId: memberShipId,
      merchantUid: merchant_uid
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('member/registration', 'POST', requestData);

        if (responseData.status === 200) {
          setIsLoading(false);
          cancel(responseData.data);
          setRerendering(!rerendering);
        }
        else if (responseData.status === 201) {
          setIsLoading(false);

          // 같은 결제건으로 이미 등록된 회원권이 있는 경우 ( 코치앱 대기승인 등에서 먼저 등록됨 ) //
          if (responseData.error === 'Already Registered') alert(t('waiting.onSitePaymentModal.alertAlreadyRegistered'));
          else alert(t('waiting.onSitePaymentModal.alertPurchaseNotFound'));

          return;
        }
        else if (responseData.status === 202) {
          alert(t('waiting.onSitePaymentModal.alertPaymentNotProcessed'));
          return;
        }
        else if (responseData.status === 401) {
          setIsLoading(false);
          alert(t('waiting.onSitePaymentModal.alertLoginRequiredShort'));
          history.push('/login');
        }
        else if (responseData.status === 409) {
          // 포인트 잔액 부족 등 서버측 사용 가능 여부 충돌 //
          setIsLoading(false);
          alert(responseData.error);
          return;
        }
        else {
          setIsLoading(false);
          alert(t('waiting.onSitePaymentModal.alertRegistrationFailed'));
          return;
        }
      }
    )();

    setIsClicked(false);
    closeFn();
  }

  // 승인일자 반환 //
  function getApprovalDate() {
    return moment(InfoViewRef.current.getApprovalDate()).format('YYYY-MM-DDTHH:mm:ss');
  }

  // 결제 종료 후 모달창 끄기 //
  function onCompletePayment(memberData) {
    setIsLoading(false);
    cancel(memberData);
    setRerendering(!rerendering);
    setIsClicked(false);
    closeFn();
  }

  return (
    <TotalModalWrapper>
      {isLoading && <RegistrationLoading />}
      {isClickedAddPaymentOption && <AddPaymentOptionModal onClickSave={onClickSavePaymentOption} onClickExit={() => setIsClickedAddPaymentOption(false)} />}
      {
        isClicked &&
        <WaitingPagePaymentModal
          isUsePaymentSystem={isUsePaymentSystem}
          name={productName}
          coach={productCoach}
          validity={productValidity}
          cash={cash}
          card={card}
          discount={discount}
          notReceived={notReceived}
          point={point}
          merchantUid={merchantUid}
          totalRegistData={totalRegistData}
          onRegist={cancelFunction}
          cancel={onCompletePayment}
          setIsLoading={setIsLoading}
          getApprovalDate={getApprovalDate}
          onClickOnSitePayment={onClickOnSitePayment} />
      }
      <ModalView>
        <MembershipBoxInnerWrapper onClick={onClickPrevSales} onMouseOver={onMouseOverPrevSales} onMouseLeave={onMouseLeavePrevSales}>
          <TextWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{userData?.userName} - {t('waiting.onSitePaymentModal.membershipPaymentApproval')}</Text>
            <CloseButton onClick={closeFn}>
              <StyledPlusIcon />
            </CloseButton>
          </TextWrapper>
          {userData?.prevSales !== undefined && userData?.prevMemberShip !== undefined && <InfoTopLevelWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={16} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.prevMembershipInfo')}</Text>
            </TitleWrapper>
            <DivisionLine margin={0} />
            <InfoBox>
              <RowWrapper>
                <PrevSalesInfoBoxWrapper marginRight={0}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('waiting.onSitePaymentModal.membership')}</Text>
                  <PrevSalesTextWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('MemberShipName')}</Text>
                  </PrevSalesTextWrapper>
                </PrevSalesInfoBoxWrapper>
                <PrevSalesInfoBoxWrapper marginRight={0}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('waiting.onSitePaymentModal.period')}</Text>
                  <PrevSalesTextWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('Date')}</Text>
                  </PrevSalesTextWrapper>
                </PrevSalesInfoBoxWrapper>
              </RowWrapper>
              <RowWrapper>
                <RowInnerWrapper>
                  <PrevSalesInfoBoxWrapper width={150} marginRight={10}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('waiting.onSitePaymentModal.paymentAmount')}</Text>
                    <PrevSalesTextWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('TotalPrice')}</Text>
                    </PrevSalesTextWrapper>
                  </PrevSalesInfoBoxWrapper>
                  <PrevSalesInfoBoxWrapper width={80} marginRight={13}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('waiting.onSitePaymentModal.notReceived')}</Text>
                    <PrevSalesTextWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('NotReceivedPrice')}</Text>
                    </PrevSalesTextWrapper>
                  </PrevSalesInfoBoxWrapper>
                </RowInnerWrapper>
                <RowInnerWrapper>
                  <PrevSalesInfoBoxWrapper width={105} marginRight={30}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('waiting.onSitePaymentModal.remainingDays')}</Text>
                    <PrevSalesDDayWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={prevSalesDDayColor} cursor='pointer'>{onCalcPrevSalesInfo('Validity')}</Text>
                    </PrevSalesDDayWrapper>
                  </PrevSalesInfoBoxWrapper>
                  <PrevSalesInfoBoxWrapper width={55}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('waiting.onSitePaymentModal.courseCount')}</Text>
                    <PrevSalesTextWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('TotalMax')}</Text>
                    </PrevSalesTextWrapper>
                  </PrevSalesInfoBoxWrapper>
                </RowInnerWrapper>
              </RowWrapper>
            </InfoBox>
          </InfoTopLevelWrapper>}
        </MembershipBoxInnerWrapper>
        <LayerTopLevelWrapper>
          <TextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={16} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.paymentInfo')}</Text>
          </TextWrapper>
          <DivisionLine margin={10} />
          <OnSiteWrapper>
                <LayerWrapper
                  padding={10}
                  gap={20}
                  style={{ zIndex: selectedPaymentOptions.length + 3 }}>
                  <InputWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.category')}</Text>
                    <OptionSelectBox
                      value={selectedCategory}
                      setValue={setSelectedCategory}
                      options={categories}
                      disabled={categories.length === 0} />
                  </InputWrapper>
                  <InputWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.membership')}</Text>
                    <OptionSelectBox
                      value={selectedMembership}
                      setValue={setSelectedMembership}
                      options={categorizedMemberships}
                      disabled={categorizedMemberships.length === 0} />
                  </InputWrapper>
                </LayerWrapper>
                <LayerWrapper
                  padding={10}
                  gap={20}
                  style={{ zIndex: selectedPaymentOptions.length + 2 }}>
                  <DateInputWrapper>
                    <InputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.startDate')}</Text>
                      <CalenderInput
                        value={startDate}
                        setValue={setStartDate}
                        disabled={false}
                        flexShrink={true}
                        placeholder={t('waiting.onSitePaymentModal.startDate')} />
                    </InputWrapper>
                    <InputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.endDate')}</Text>
                      <CalenderInput
                        value={endDate}
                        setValue={setEndDate}
                        disabled={false}
                        flexShrink={true}
                        placeholder={t('waiting.onSitePaymentModal.endDate')} />
                    </InputWrapper>
                  </DateInputWrapper>
                  <InputWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.maxCourseCount')}</Text>
                    <UnitInputWrapper>
                      <CustomInput
                        value={totalMax === -1 ? t('waiting.onSitePaymentModal.noLimit') : totalMax}
                        setValue={onChangeTotalMax}
                        placeholder='0'
                        disabled={totalMax === -1}
                        flexShrink={true} />
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.courseUnit')}</Text>
                    </UnitInputWrapper>
                  </InputWrapper>
                </LayerWrapper>
                <LayerWrapper
                  padding={10}
                  gap={20}
                  style={{ zIndex: selectedPaymentOptions.length + 1 }}>
                  <InputWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.paymentDate')}</Text>
                    <CalenderInput
                      value={approvalDate}
                      setValue={setApprovalDate}
                      disabled={false}
                      placeholder={t('waiting.onSitePaymentModal.paymentDate')} />
                  </InputWrapper>
                  <RowDivisionLine />
                  <InputWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.membershipPrice')}</Text>
                    <UnitInputWrapper>
                      <CustomInput
                        value={selectedMembership.id === 0 ? '0' : selectedMembership.price.toLocaleString('ko-KR')}
                        placeholder='0'
                        disabled={true}
                        textAlign='right' />
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.wonUnit')}</Text>
                    </UnitInputWrapper>
                  </InputWrapper>
                </LayerWrapper>
                <PaymentOptionsListWrapper>
                  {
                    selectedPaymentOptions.map((data, index) => (
                      <LayerWrapper
                        key={'SelectedPaymentOptions-' + index}
                        padding={10}
                        gap={20}
                        isPaymentMethod={true}
                        style={{ zIndex: selectedPaymentOptions.length - index }}>
                        <InputWrapper>
                          <PaymentOptionTitleWrapper>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.paymentMethod') + (index === 0 ? '' : index + 1)}</Text>
                            {
                              index !== 0 &&
                              <DeleteButton onClick={() => onClickDeletePaymentOptions(index)}>
                                <DeleteIcon src={WhiteTrashIcon} />
                              </DeleteButton>
                            }
                          </PaymentOptionTitleWrapper>
                          <PaymentOptionSettingSelectBox
                            index={index}
                            value={data}
                            setValue={onChangeSelectedPaymentOptions}
                            options={paymentOptions}
                            disabled={paymentOptions.length === 0}
                            onClickAdditionOption={onClickAdditionOption}
                            onClickDeleteOption={onClickDeleteOption} />
                        </InputWrapper>
                        <RowDivisionLine />
                        <InputWrapper>
                          <PaymentOptionTitleWrapper>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.receivedPrice')}</Text>
                            {(data.paymentOptionId === 0 || (data.paymentOptionId === undefined && data.id === 0)) && data.name === '포인트' && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subKey} cursor='default'>{t('waiting.onSitePaymentModal.pointAvailable', { point: totalPoint.toLocaleString('ko-KR') })}</Text>}
                          </PaymentOptionTitleWrapper>
                          <UnitInputWrapper>
                            <PaymentOptionCustomInput
                              index={index}
                              value={(data.price ?? 0).toLocaleString('ko-KR')}
                              setValue={onChangePaymentOptionPrice}
                              placeholder='0'
                              disabled={false}
                              textAlign='right'
                              isFlex={true} />
                            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.wonUnit')}</Text>
                          </UnitInputWrapper>
                        </InputWrapper>
                      </LayerWrapper>
                    ))
                  }
                </PaymentOptionsListWrapper>
                <AddPaymentOptionButton onClick={onClickAddPaymentOptions}>{t('waiting.onSitePaymentModal.addPaymentMethod')}</AddPaymentOptionButton>
                <LayerWrapper
                  padding={10}
                  gap={20}>
                  <InputWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.discountAmount')}</Text>
                    <UnitInputWrapper>
                      <DiscountAmountInput
                        value={discount.toLocaleString('ko-KR')}
                        setValue={(value) => onChangeDiscount(value)}
                        placeholder='0'
                        isFlex={true} />
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subKey} cursor='default'>{t('waiting.onSitePaymentModal.wonUnit')}</Text>
                    </UnitInputWrapper>
                  </InputWrapper>
                  <RowDivisionLine />
                  <InputWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('waiting.onSitePaymentModal.notReceived')}</Text>
                    <UnitInputWrapper>
                      <NotReceivedInputView>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.pointRed} cursor='default'>{notReceived.toLocaleString('ko-KR')}</Text>
                      </NotReceivedInputView>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.pointRed} cursor='default'>{t('waiting.onSitePaymentModal.wonUnit')}</Text>
                    </UnitInputWrapper>
                  </InputWrapper>
                </LayerWrapper>
          </OnSiteWrapper>
        </LayerTopLevelWrapper>
        <ButtonWrapper>
          <ExitButton onClick={closeFn}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('waiting.onSitePaymentModal.cancel')}</Text>
          </ExitButton>
          <SaveButton onClick={onClickRegistrationButton}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='pointer'>{t('waiting.onSitePaymentModal.save')}</Text>
          </SaveButton>
        </ButtonWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}

export default OnSitePaymentModal;

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: 60px 0px;
  padding: 20px 10px;

  width: ${props => props.isLinkPay ? '532px' : '556px'};

  gap: 10px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const LinkPayBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  margin: -20px -40px 0px 0px;

  width: 100%;
`;

const LinkPayBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 102px;
  height: 27px;

  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;

  background-color: #6DD49E;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: space-between;
  align-items: center;

  width: 100%
`;

const InfoTopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  padding: 10px;

  width: 100%;
  box-sizing: border-box;

  gap: 10px;

  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 10px;
`;

const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }

    & * {
      cursor: pointer !important;
    }
  }
`;

const RowInnerWrapper = styled.div`
  display: flex;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
`;

const PrevSalesInfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-right: ${props => props.marginRight}px;

  width: ${props => props.width ? `${props.width}px` : '100%'};
  height: 48px;

  overflow: hidden;
  gap: 8px;
`;

const PrevSalesTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 20px;

  overflow: hidden; 
`;

const PrevSalesDDayWrapper = styled.div`
  display: flex;

  justify-content: center;
  align-item: center;

  width: 100%;
  height: 20px;

  overflow: hidden;

  border-radius: 2px;

  background-color: ${props => props.theme.line};
`;

const MembershipBoxInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const LayerTopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

const LayerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: ${props => props.isSpaceBetween ? 'space-between' : 'center'};
  align-items: center;

  margin-top: ${props => props.marginTop}px;
  padding: ${props => props.isPaymentMethod ? `0 ${props.padding}px ${props.padding}px ${props.padding}px` : `${props.padding}px`};

  width: 100%;

  gap: ${props => props.gap}px;

  box-sizing: border-box;
`;

const LinkPayWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const OnSiteWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  min-width: 0;

  gap: 5px;
`;

const UnitInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  min-width: 0;

  gap: 5px;
`;

const LickoPayUnitInputWrapper = styled.div`
  display: flex;

  justify-content: flex-start;
  align-items: center;

  gap: ${props => props.gap}px;

  flex-shrink: 0;
`;

const MembershipNameWrapper = styled.div`
  display: flex;

  justify-content: flex-start;
  align-items: center;

  overflow: hidden;
  min-width: 0;

  & > p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

const SubscriptionWrapper = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  padding: 0px 5px;

  border-radius: 2px;

  background-color: ${props => props.theme.primary};
`;

const LickoPayCalendarWrapper = styled.div`
  display: flex;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: ${props => props.gap}px;
`;

const DateInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: flex-start;

  width: 100%;
  min-width: 0;

  gap: 10px;
`;

const NotReceivedInputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

	padding: 0 8px;

  flex: 1;
  height: 30px;

	border: 1px solid ${props => props.theme.subBackground};
	border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
`;

const ReadOnlyInputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  padding: 0 8px;

  width: ${props => props.width}px;
  height: 30px;

  border: 1px solid ${props => props.borderColor || '#D4D4D4'};
  border-radius: 5px;
  background-color: #FFFFFF;
`;


const PaymentInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: ${props => props.marginTop}px;

  width: 100%;
`;

const DivisionLine = styled.div`
  margin-top: ${props => props.margin}px;
  margin-bottom: ${props => props.margin}px;

  width: 100%;
  height: 1px;

  background-color: ${props => props.theme.line};
`;

const RowDivisionLine = styled.div`
  flex-shrink: 0;

  width: 1px;
  height: 54px;

  background-color: ${props => props.theme.line};
`;

const PaymentOptionsListWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

const AddPaymentOptionButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: 100%;
  height: 40px;
  
  border-radius: 20px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.text};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      color: ${props => props.theme.background};
      background-color: ${props => props.theme.subKey};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 21px;
  height: 21px;

  border-radius: 2px;
  background-color: ${props => props.theme.pointRed}80;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.pointRed};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteIcon = styled.img`
  width: 14px;
  height: 14px;
`;

const PaymentOptionTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 20px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0 27px 0 27px;

  height: 40px;
  flex-shrink: 0;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.line};
    }
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.subKey};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.disabled ? props.theme.line : props.theme.subKeyHover};
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;

  justify-content: space-between;
  align-items: center;

  padding: 10px 10px 5px 10px;

  width: ${props => props.width ? `${props.width}px` : '100%'};
`;

const CloseButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-right: 10px;

  width: 24px;
  height: 24px;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledPlusIcon = styled(PlusSvg)`
  width: 20px;
  height: 20px;

  transform: rotate(45deg);

  & path {
    fill: ${props => props.theme.line};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0 0 0 0;

  color: ${props => props.color};

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  transition: all 0.3s ease-in-out;
`;